import { keysToCamel } from "@lib/snakeTocamel"
/**
 * @description parser for address dls data
 * @param {*} widgets
 * @param {integer} currentPageNumber
 * @param {integer} totalNumberOfAddress
 * @param {*} existingAddress
 * @param {*} existingCta
 * @param {integer} addressIdSelected
 * @returns addressObject

 */
export const parseAddressData = (
    widgets,
    currentPageNumber = 0,
    totalNumberOfAddress = 0,
    existingAddress = [],
    existingCta = {},
    addressIdSelected = null
) => {
    let selectedAddressId = null
    let addressCta = {}
    let groupedAddresses = []
    let numberOfAddress = 0
    let hasMore = false
    let addressList
    let noAddressFound
    let header
    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "list_address": {
                header = widget?.header
                addressList = {
                    secondaryCta: keysToCamel(widget?.data.secondary_cta),
                    groupedAddresses: widget?.data?.grouped_addresses?.map((item) => {
                        if (currentPageNumber > 0 && item?.header === "Recent addresses") {
                            return
                        } else {
                            return {
                                header: item.header,
                                addresses: item?.addresses?.map((address) => {
                                    numberOfAddress++
                                    if (address?.is_selected) {
                                        selectedAddressId = address?.id
                                    }
                                    if (address?.cta) {
                                        addressCta[address?.id] = keysToCamel(address?.cta)
                                    }
                                    return {
                                        id: address?.id,
                                        name: address?.address_name
                                            ? address?.address_name
                                            : address?.address_type
                                            ? address?.address_type
                                            : "",
                                        addressText:
                                            [address?.street1, address?.city, address?.state]
                                                .filter(Boolean)
                                                .join(", ")
                                                .concat(` (${address?.pincode})`) || "",
                                        streetName: address.street2 || "",
                                        street3: address.street3 || "",
                                        city: address?.city,
                                        state: address?.state,
                                        pincode: address?.pincode,
                                        recipientName: address?.name,
                                        recipientPhone: address?.contact_number,
                                        editCta: keysToCamel(address?.edit_cta),
                                        removeCta: keysToCamel(address?.remove_cta),
                                        isDisabled: address?.is_disabled,
                                        errorMsg: address?.display_text,
                                        addressServiceabilityGaData: address?.address_serviceability_ga_data,
                                        lat: address?.geodata_latitude,
                                        lng: address?.geodata_longitude,
                                        geodataUpdateRequired: address?.is_geodata_update_required,
                                    }
                                }),
                            }
                        }
                    }),
                }
                noAddressFound = widget?.no_address_found
                break
            }
        }
    })
    if (numberOfAddress === 10) {
        hasMore = true
    }
    if (currentPageNumber > 0) {
        selectedAddressId = addressIdSelected
        let recentAddress = existingAddress[0]
        addressList.groupedAddresses[0] = recentAddress
        groupedAddresses = existingAddress[1].addresses
        let combinedAddress = groupedAddresses.concat(addressList.groupedAddresses[1].addresses)
        addressList.groupedAddresses[1].addresses = combinedAddress
        let combinedAddressCta = { ...existingCta, ...addressCta }
        addressCta = combinedAddressCta
    }
    return {
        header,
        addressList,
        defaultSelectedAddressId: selectedAddressId,
        addressCta: addressCta,
        totalNumberOfAddress: numberOfAddress + currentPageNumber * totalNumberOfAddress,
        hasMore: hasMore,
        currentPageNumber: currentPageNumber,
        noAddressFound,
    }
}
/**
 *
 * @param {object} widgets
 * @param {*} currentPageNumber
 * @param {*} totalNumerOfAddress
 * @param {*} existingAddress
 * @param {*} existingCta
 * @param {*} addressIdSelected
 * @returns{object} address object
 */
export const parseGetAddressData = (
    widgets,
    currentPageNumber = 0,
    totalNumerOfAddress = 0,
    existingAddress = [],
    existingCta = {},
    addressIdSelected = null
) => {
    let widgetData = {}
    let selectedAddressId = null
    let addressCta = {}
    let groupedAddresses = []
    let numberOfAddress = 0
    let hasMore = false
    widgets?.forEach((widget) => {
        switch (widget.type) {
            case "list_address": {
                widgetData["listAddress"] = {
                    secondaryCta: {
                        label: widget?.data.secondary_action?.text,
                        functionMap: "addNewAddress",
                    },
                    groupedAddresses: widget?.data?.grouped_addresses?.map((item) => {
                        if (currentPageNumber > 0 && item?.header === "Recent addresses") {
                            return
                        } else {
                            return {
                                header: item.header,
                                addresses: item?.addresses?.map((address) => {
                                    numberOfAddress++
                                    if (address?.is_selected) {
                                        selectedAddressId = address?.id
                                    }
                                    if (address?.cta) {
                                        addressCta[address?.id] = {
                                            action: address?.cta?.action,
                                            is_disabled: address?.cta?.is_disabled,
                                            target_url: address?.cta?.target_url,
                                            text: address?.cta?.text,
                                            addressServiceabilityGaData:
                                                address?.address_serviceability_ga_data,
                                            errorMsg: address?.display_text,
                                            pincode: address?.pincode,
                                        }
                                    }
                                    return {
                                        id: address?.id,
                                        name: address?.address_name
                                            ? address?.address_name
                                            : address?.address_type
                                            ? address?.address_type
                                            : "",
                                        addressText:
                                            [address?.street1, address?.city, address?.state]
                                                .filter(Boolean)
                                                .join(", ")
                                                .concat(` (${address?.pincode})`) || "",
                                        streetName: address.street2 || "",
                                        city: address?.city,
                                        state: address?.state,
                                        pincode: address?.pincode,
                                        recepientName: address?.name,
                                        recepientPhone: address?.contact_number,
                                        actionLabelFirst: address?.action1.text,
                                        actionLabelSecond: address?.action2.text,
                                        isDisabled: address?.is_disabled,
                                        errorMsg: address?.display_text,
                                        addressServiceabilityGaData: address?.address_serviceability_ga_data,
                                        lat: address?.geodata_latitude,
                                        lng: address?.geodata_longitude,
                                        geodataUpdateRequired: address?.is_geodata_update_required,
                                    }
                                }),
                            }
                        }
                    }),
                }
                break
            }
        }
    })
    if (numberOfAddress === 10) {
        hasMore = true
    }
    if (currentPageNumber > 0) {
        selectedAddressId = addressIdSelected
        let recentAddress = existingAddress[0]
        widgetData["listAddress"].groupedAddresses[0] = recentAddress
        groupedAddresses = existingAddress[1].addresses
        let combinedAddress = groupedAddresses.concat(widgetData["listAddress"].groupedAddresses[1].addresses)
        widgetData["listAddress"].groupedAddresses[1].addresses = combinedAddress
        let combinedAddressCta = { ...existingCta, ...addressCta }
        addressCta = combinedAddressCta
    }
    return {
        widget: widgetData,
        selectedAddressId: selectedAddressId,
        addressCta: addressCta,
        totalNumerOfAddress: numberOfAddress + currentPageNumber * totalNumerOfAddress,
        hasMore: hasMore,
        currentPageNumber: currentPageNumber,
    }
}
/**
 *
 * @param {object} data
 * @returns {object} reverse geodata
 */
export const parseReverseGeoData = (data) => {
    let reverseGeoData = {
        header: data.street2
            ? data.street2
            : data.city
            ? data.city
            : data.state
            ? data.state
            : data.country
            ? data.country
            : data.pincode
            ? data.pincode
            : "",
        address: data.street3,
        pincode: data.pincode ? data.pincode : "",
        city: data.city ? data.city : "",
        state: data.state ? data.state : "",
        country: data.country ? data.country : "",
        geodata_source: data.geodata_source,
    }
    return reverseGeoData
}
/**
 * Creating parsed data for updateAddressDialogBox for which this function is called
 * @param {object} data
 * @return {object} updateAddressDialogBox with it's type and data
 */
export const parseUpdateAddressData = (data) => {
    let updateAddressDialogBox = {
        description: data?.description,
        header: data?.header,
        icon: data?.icon,
        primaryCta: data?.primary_cta?.text,
        secondaryCta: data?.secondary_cta?.text,
    }
    return updateAddressDialogBox
}

/**
 * @description Parses popup data for service unavailable popup
 * @param {object} data - The data object containing popup information
 * @returns {object} Parsed popup data
 */
export const parsePopupdata = (data) => {
    const popupData = data?.popups?.service_unavailable
    const parsedData = {
        image: {
            ...popupData?.image,
            height: "96px",
            width: "96px",
        },
        header: popupData?.header,
        description: popupData?.description,
        cta: keysToCamel(popupData?.cta),
        gaDetails: popupData?.gaDetails,
    }
    return parsedData
}
